import axios from '@utils/http'
import analyticsService from '@utils/analytics-service'

export const state = {
  currentUser: getSavedState('auth.currentUser'),
  isAppLogin: getSavedState('appLogin')
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
  SET_APP_LOGIN(state, newValue) {
    state.isAppLogin = newValue
    saveState('appLogin', newValue)
  }
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
    isAppLogin() {
      return state.isAppLogin === true
    }
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/end_user/session', { username, password })
      .then((response) => {
        const user = response.data
        commit('SET_CURRENT_USER', user)

        analyticsService.identifyUser(user)
        return user
      })
  },

  // Registers a new user.
  register({ commit, dispatch, getters }, { username, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/end_user/register', { username, password })
      .then((response) => {
        const user = response.data
        commit('SET_CURRENT_USER', user)
        analyticsService.identifyUser(user)
        return user
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state, getters }) {
    if (!state.currentUser) return Promise.resolve(null)

    return axios
      .get('/api/end_user/session')
      .then((response) => {
        const user = response.data

        // If the user has logged out while this request was in flight
        // do not re-log them in
        if (getters.loggedIn) {
          commit('SET_CURRENT_USER', user)
          return user
        }

        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          commit('SET_CURRENT_USER', null)
        } else {
          console.warn(error)
        }
        return null
      })
  },

  requestPasswordReset({ commit, dispatch, getters }, { email } = {}) {
    return axios
      .post('/api/end_user/resetPassword', { email })
      .then((response) => {
        return response.data
      })
  },

  performPasswordReset(
    { commit, dispatch, getters },
    { password, token } = {}
  ) {
    return axios
      .post('/api/end_user/performPasswordReset', { password, token })
      .then((response) => {
        return response.data
      })
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  if (state === null) {
    window.localStorage.removeItem(key);
  } else {
    window.localStorage.setItem(key, JSON.stringify(state))
  }
}

function setDefaultAuthHeaders(state) {
  if (state.currentUser === null || !state.currentUser.token) {
    console.log('removing auth headers')
    delete axios.defaults.headers.common.Authorization;
  } else {
    console.log('setting auth header to', state.currentUser.token)
    axios.defaults.headers.common.Authorization = state.currentUser.token
  }
}
